export default __webpack_public_path__ + "static/media/showroom40.34a8e1fb.jpg";